import { KendoBaseComponent, KendoBaseDatasourceComponent } from '@progress/kendo-base-components-vue-wrapper'
import TreeMapProps from './TreeMapProps'


export default {
    props: TreeMapProps,
    emits: {
        'kendowidgetready': null
    },
    mixins: [
        KendoBaseComponent,
        KendoBaseDatasourceComponent
    ],
    mounted() {
        kendo.jQuery(this.$el).kendoTreeMap(this.widgetOptions)
        if(this.v3) {
            this.ready()
            this.$emit('kendowidgetready', this.kendoWidget())
        } else {
            this.$emit('kendowidgetready', this.kendoWidget())
        }
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoTreeMap()
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-treemap-vue-wrapper/src/KendoTreeMap/KendoTreeMapMixin.js